export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Request for technical support"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["from"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add message"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Files"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You can upload one or more files. \nThe maximum file size is 10Mb."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Message text"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
}